import type AjaxService from 'garaje/services/ajax';

export interface PolicyDraftResponse {
  automaticReevaluation: boolean;
}

export async function fetchPolicyDraft(ajax: AjaxService, inviteId: string): Promise<PolicyDraftResponse> {
  return ajax.request<PolicyDraftResponse>(`/a/visits/api/v1/workflows/invite/${inviteId}/policy-draft`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
}
